export enum ChatBotTrackEvents {
  COPILOT_BUBBLE_TAP = 'COPILOT_bubble_tap',
  COPILOT_WELCOME_VIDEO = 'COPILOT_welcome_video',
  COPILOT_GET_STARTED = 'COPILOT_lets_get_started',
  COPILOT_TERMS_OK = 'COPILOT_terms_ok',
  COPILOT_CLOSE = 'COPILOT_close',
  COPILOT_CLOSE_CONFIRM = 'COPILOT_close_confirm',
  COPILOT_CLOSE_REJECT = 'COPILOT_close_reject',
  COPILOT_SEND_TEXT = 'COPILOT_send_text',
  COPILOT_SEND_AUDIO = 'COPILOT_send_audio',
  COPILOT_HINT_SELECTED = 'COPILOT_hint_selected',
  COPILOT_HINTS_ON = 'COPILOT_hints_on',
  COPILOT_HINTS_OFF = 'COPILOT_hints_off',
  COPILOT_CHAT_BUBBLE_OPTIONS = 'COPILOT_chat_bubble_options',
  COPILOT_CHAT_THUMB_UP = 'COPILOT_chat_thumb_up',
  COPILOT_CHAT_THUMB_DOWN = 'COPILOT_chat_thumb_down',
  COPILOT_LISTEN = 'COPILOT_listen',
  COPILOT_TRANSLATE = 'COPILOT_translate',
  COPILOT_RECORDING_CANCEL = 'COPILOT_recording_cancel',
  COPILOT_AUTOPLAY_ON = 'COPILOT_autoplay_on',
  COPILOT_AUTOPLAY_OFF = 'COPILOT_autoplay_off',
  COPILOT_AUDIO_INTERRUPT = 'COPILOT_audio_interrupt',
  COPILOT_ASK_JENNY_MINILESSONS = 'COPILOT_ask_jenny_minilessons',
}

export type ChatBotTrackEventsData = {
  event: ChatBotTrackEvents;
};
